import { text } from '@pdfme/schemas';

const fixedTextSchema = {
  pdf: text.pdf,
  ui: text.ui,
  propPanel: {
    ...text.propPanel,
    defaultSchema: {
      ...text.propPanel.defaultSchema,
      type: 'fixedText',
    },
  },
};

export default fixedTextSchema;
